var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import classnames from 'classnames';
import React from 'react';
import Notification from 'rmc-notification';
import ReactDOM from 'react-dom';
import './index.less';
import styles from './index.module.less';
import { unlockContaier, lockContaier } from '@/utils/util';
var SHORT = 3;
var REACT_DIALOG_COMPONENT_TIMER = 'react-dialog-component-timer';
var REACT_DIALOG_COMPONENT_ID = 'react-dialog-component';
var REACT_TOAST_COMPONENT_TIMER = 'react-toast-component-timer';
var REACT_TOAST_COMPONENT_ID = 'react-toast-component';
var config = {
    duration: SHORT,
    mask: true,
};
var messageInstance;
var prefixCls = 'am-toast';
function getMessageInstance(mask, callback) {
    var _a;
    if (messageInstance) {
        messageInstance.destroy();
        messageInstance = null;
    }
    Notification.newInstance({
        prefixCls: prefixCls,
        style: {},
        transitionName: 'am-fade',
        className: classnames((_a = {},
            _a[prefixCls + "-mask"] = mask,
            _a[prefixCls + "-nomask"] = !mask,
            _a)),
    }, function (notification) { return callback && callback(notification); });
}
function notice(content, type, duration, onClose, mask) {
    if (duration === void 0) { duration = config.duration; }
    if (mask === void 0) { mask = config.mask; }
    var iconTypes = {
        info: '',
        success: 'success',
        fail: 'fail',
        offline: 'dislike',
        loading: 'loading',
    };
    var iconType = iconTypes[type];
    getMessageInstance(mask, function (notification) {
        messageInstance = notification;
        notification.notice({
            duration: duration,
            style: {},
            content: !!iconType ? (React.createElement("div", { className: prefixCls + "-text " + prefixCls + "-text-icon", role: "alert", "aria-live": "assertive" },
                React.createElement("div", { className: prefixCls + "-text-info" }, content))) : (React.createElement("div", { className: prefixCls + "-text", role: "alert", "aria-live": "assertive" },
                React.createElement("div", null, content))),
            closable: true,
            onClose: function () {
                if (onClose) {
                    onClose();
                }
                notification.destroy();
                notification = null;
                messageInstance = null;
            },
        });
    });
}
var Toast = {
    SHORT: SHORT,
    LONG: 8,
    ScrollTop: 0,
    show: function (content, duration, mask) {
        return notice(content, 'info', duration, function () { }, mask);
    },
    info: function (content, duration, onClose, mask) {
        return notice(content, 'info', duration, onClose, mask);
    },
    config: function (conf) {
        if (conf === void 0) { conf = {}; }
        var _a = conf.duration, duration = _a === void 0 ? SHORT : _a, mask = conf.mask;
        config.duration = duration;
        if (mask === false) {
            config.mask = false;
        }
    },
    showToastComponent: function (children, duration) {
        if (duration === void 0) { duration = 1500; }
        if (window[REACT_TOAST_COMPONENT_TIMER]) {
            clearTimeout(window[REACT_TOAST_COMPONENT_TIMER]);
        }
        var div = document.getElementById(REACT_TOAST_COMPONENT_ID);
        if (div) {
            document.body.removeChild(div);
        }
        div = document.createElement('div');
        div.id = REACT_TOAST_COMPONENT_ID;
        div.style.position = 'fixed';
        div.style.zIndex = '2000';
        document.body.appendChild(div);
        div.className = styles.show;
        ReactDOM.render(React.createElement(ToastComponent, { children: children }), div);
        if (duration === 0)
            return;
        window[REACT_TOAST_COMPONENT_TIMER] = setTimeout(function () {
            Toast.hideToastComponent();
        }, duration);
    },
    hideToastComponent: function () {
        var div = document.getElementById(REACT_TOAST_COMPONENT_ID);
        if (!div)
            return;
        div.className = styles.fade;
        window[REACT_TOAST_COMPONENT_TIMER] = setTimeout(function () {
            div = document.getElementById(REACT_TOAST_COMPONENT_ID);
            if (!div)
                return;
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        }, 300);
    },
    showComponent: function (children, duration, lockBody, lockElementId) {
        if (duration === void 0) { duration = 1500; }
        if (lockBody === void 0) { lockBody = false; }
        if (lockElementId) {
            lockContaier(lockElementId);
            window['lockElementId'] = lockElementId;
        }
        if (window[REACT_DIALOG_COMPONENT_TIMER]) {
            clearTimeout(window[REACT_DIALOG_COMPONENT_TIMER]);
        }
        var div = document.getElementById(REACT_DIALOG_COMPONENT_ID);
        if (div) {
            document.body.removeChild(div);
        }
        div = document.createElement('div');
        div.id = REACT_DIALOG_COMPONENT_ID;
        div.classList.add(styles.showComponent);
        document.body.appendChild(div);
        if (lockBody) {
            div.addEventListener('touchmove', preventDefault, false);
            // Toast.setBodyLocker()
        }
        if (duration !== 0) {
            window[REACT_DIALOG_COMPONENT_TIMER] = setTimeout(function () {
                Toast.hideComponent();
            }, duration);
        }
        var renderComponent = function (children) {
            return new Promise(function (resolve) {
                return ReactDOM.render(React.createElement(children.type, __assign({}, children.props, { fourceUpdate: resolve })), div);
            }).then(function (newState) {
                return renderComponent(React.createElement(children.type, __assign({}, children.props, newState)));
            });
        };
        return renderComponent(children);
    },
    hideComponent: function () {
        var div = document.getElementById(REACT_DIALOG_COMPONENT_ID);
        if (!div)
            return;
        div.className = styles.fade;
        window[REACT_DIALOG_COMPONENT_TIMER] = setTimeout(function () {
            div = document.getElementById(REACT_DIALOG_COMPONENT_ID);
            if (!div)
                return;
            div.removeEventListener('touchmove', preventDefault, false);
            // Toast.setBodyUnLocker()
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
            unlockContaier(window['lockElementId']);
        }, 300);
    },
    setBodyLocker: function () {
        var getTopPosition = document.documentElement.scrollTop + document.body.scrollTop;
        Toast.ScrollTop = getTopPosition;
        document.body.style.position = 'fixed';
        document.body.style.top = (getTopPosition * -1) + 'px';
        document.body.style.overflow = 'hidden';
        document.body.style.width = '100%';
        document.body.style.background = '#555';
    },
    setBodyUnLocker: function () {
        document.body.style.cssText = "";
        document.documentElement.scrollTop = Toast.ScrollTop;
    }
};
export default Toast;
function Component(props) {
    return (React.createElement("div", { className: styles.container }, props.children));
}
function ToastComponent(props) {
    return (React.createElement("div", { className: styles.toast }, props.children));
}
function preventDefault(e) {
    e.preventDefault();
}



//////////////////
// WEBPACK FOOTER
// ./src/components/toast/index.tsx
// module id = 194
// module chunks = 39